import { Component } from '@angular/core';
import { SiteServices } from '../../services/siteservices';

@Component({
    selector: 'cachefrm',
    templateUrl: '/templates/get/Settings/cache_frm',
})
export class CacheSettingsComponent {
    PCODE = 'SETTINGS';
    public rows = [];
    
    public keys = [];
    public isConnected: boolean = false;
    public numOfKeys: number = 0;

    constructor(public siteServices: SiteServices) {
        this.getIsConnected();
    }

    getIsConnected() {
        this.siteServices.provider_Execute(
            this.PCODE,
            'ISCACHESERVERCONNECTED',
            {},
            (data) => {
                this.isConnected = data.TagObject;

                if (this.isConnected){
                    this.getAllKeys();
                }
            }
        );
    }
    
    removeAllKeys() {
        this.siteServices.provider_Execute(
            this.PCODE,
            'REMOVEALLCACHEKEYS',
            {},
            (data) => {
                this.getAllKeys();
            }
        );
    }

    getAllKeys() {
        this.siteServices.provider_Execute(
            this.PCODE,
            'GETALLCACHEKEYS',
            {},
            (data) => {
                this.numOfKeys = data.TagObject.length;
                this.keys = data.TagObject;
            }
        );
    }
}
